export const SUSPENSE_LOADER_PROPS = {
  testId: 'suspense-loader',
  fullScreen: true,
};
